import React, { useState, useEffect } from "react";
import { collection, getDocs, doc, getDoc, updateDoc, query, where } from "firebase/firestore";
import { productDb } from "../firebaseProducts"; // adjust path to your Firestore config

const FirestoreUpdater = () => {
  const [collections] = useState(["kids-accessories-menu","kids-apparel-menu","adult-accessories-list-menu","adult-list-menu","drinkwear-menu","full-kids-accessories","full-kids-white","kids-apparel","kids-apparel-white-menu","full-adult-accessories","adult-apparel","full-drinkwear"
]); // 🔹 Add your collections here
  const [selectedCollection, setSelectedCollection] = useState("");
  const [styleNumber, setStyleNumber] = useState("");
  const [docId, setDocId] = useState(null);
  const [fields, setFields] = useState([]);
  const [selectedField, setSelectedField] = useState("");
  const [newValue, setNewValue] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch document fields when style number changes
  useEffect(() => {
    const fetchDocument = async () => {
      if (!selectedCollection || !styleNumber) return;

      setLoading(true);
      try {
        const q = query(
          collection(productDb, selectedCollection),
          where("Style", "==", styleNumber) // 🔹 assumes "Style" is the field for style number
        );
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const docSnap = querySnapshot.docs[0];
          setDocId(docSnap.id);
          setFields(Object.keys(docSnap.data())); // extract all field names
        } else {
          setDocId(null);
          setFields([]);
          alert("No document found for this style number.");
        }
      } catch (err) {
        console.error("Error fetching document:", err);
      }
      setLoading(false);
    };

    fetchDocument();
  }, [styleNumber, selectedCollection]);

  // Update Firestore field
  const handleUpdate = async () => {
    if (!docId || !selectedField) return alert("Select a field to update");

    try {
      const ref = doc(productDb, selectedCollection, docId);
      await updateDoc(ref, { [selectedField]: newValue });
      alert(`✅ Updated ${selectedField} to "${newValue}"`);
      setNewValue("");
    } catch (err) {
      console.error("Error updating document:", err);
      alert("❌ Failed to update document");
    }
  };

  return (
    <div className="p-6 max-w-md mx-auto bg-white rounded-2xl shadow-md space-y-4">
      <h2 className="text-xl font-bold">Firestore Updater</h2>

      {/* Select Collection */}
      <select
        value={selectedCollection}
        onChange={(e) => setSelectedCollection(e.target.value)}
        className="w-full p-2 border rounded"
      >
        <option value="">Select Collection</option>
        {collections.map((col) => (
          <option key={col} value={col}>
            {col}
          </option>
        ))}
      </select>

      {/* Enter Style Number */}
      <input
        type="text"
        placeholder="Enter Style Number"
        value={styleNumber}
        onChange={(e) => setStyleNumber(e.target.value)}
        className="w-full p-2 border rounded"
      />

      {/* Field Selector */}
      {fields.length > 0 && (
        <select
          value={selectedField}
          onChange={(e) => setSelectedField(e.target.value)}
          className="w-full p-2 border rounded"
        >
          <option value="">Select Field</option>
          {fields.map((f) => (
            <option key={f} value={f}>
              {f}
            </option>
          ))}
        </select>
      )}

      {/* Input for New Value */}
      {selectedField && (
        <input
          type="text"
          placeholder={`Enter new value for ${selectedField}`}
          value={newValue}
          onChange={(e) => setNewValue(e.target.value)}
          className="w-full p-2 border rounded"
        />
      )}

      {/* Update Button */}
      <button
        onClick={handleUpdate}
        disabled={!selectedField || !newValue || loading}
        className="w-full bg-blue-600 text-black p-2 rounded disabled:bg-gray-400"
      >
        {loading ? "Updating..." : "Update Field"}
      </button>
    </div>
  );
};

export default FirestoreUpdater;
